import { useEffect, useState } from "react";
import { Col, Form, InputGroup, Nav, Row } from "react-bootstrap";
import { getAllDonationStoreItems } from "../services/DonationStoreService";
import { useLayout } from "../Context/LayoutProvider";
import search from '../images/search.svg';
import { LinkContainer } from "react-router-bootstrap";

export function DonationStorePreview() {
  const { setFullWidth } = useLayout();
  const [donationStore, setDonationStore] = useState(null);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [visibleCategory, setVisibleCategory] = useState("all");

  useEffect(() => {
    setFullWidth(true);
    return () => setFullWidth(false);
  }, [setFullWidth]);

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        const data = await getAllDonationStoreItems();
        if (!cancelled) setDonationStore(data.result);
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    }

    load();
    return () => { cancelled = true; };
  }, []);

  function onSearchInput(e) {
    setSearchTerm(e.currentTarget.value);
  }

  if (error) {
    return (
      <div className="loading-container">
        <p>Failed to load Paragon Store: {error}</p>
      </div>
    );
  }

  if (!donationStore) {
    return (
      <div className="loading-container">
        <p>Paragon Store</p>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div>
      <Row>
        <Col xs={12} md={6}>
          <h1 className="white">Paragon Store</h1>
        </Col>
        <Col>
          <InputGroup className="mb-3">
            <InputGroup.Text><img style={{width: "16px"}} src={search} alt="search"/></InputGroup.Text>
            <Form.Control placeholder="Search the Paragon Store" aria-label="Search the Paragon Store" onInput={onSearchInput}/>
          </InputGroup>
        </Col>
      </Row>

      <hr className="white-hr"/>

      <Row>
        <Col xs={12} md={2}>
          <Nav defaultActiveKey="filter-all" className="flex-column store-categories">
            <p>Item Categories</p>
            <Nav.Link eventKey="filter-all" onClick={() => setVisibleCategory("all")}>All Items</Nav.Link>
            {getItemCategories(donationStore, setVisibleCategory)}
          </Nav>
        </Col>
        <Col>
          <Row>
            {getStore(donationStore, visibleCategory, searchTerm)}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

function getItemCategories(data, setCategory) {
  return [...new Set(data.map((item) => item.type))].map((item) => (
    <Nav.Link key={item} eventKey={`filter-${item}`} onClick={() => setCategory(item)}>{item}</Nav.Link>
  ));
}

function getStore(data, category, searchTerm) {
  return data
    .filter((item) => {
      if (category !== "all" && category !== item.type) return false;
      const searchable = (item.name + item.description + item.type + item.price).toLowerCase();
      return searchTerm.toLowerCase().split(" ").every((term) => {
        return term.trim() === "" || searchable.includes(term);
      });
    })
    .map((item) => (
      <Col key={item.id} xl={4} md={6} data-type={item.type}>
        <div className="store-item">
          <Row>
            <Col xs={3}>
              <img loading="lazy" style={{width: "100%"}} src={require(`../images/DonationItems/${item.img_name}`)} alt={`Icon for ${item.name}`}/>
            </Col>
            <Col xs={9}>
              <div style={{paddingLeft: "8px"}}>
                <p className="item-name" style={{margin: "0"}}>{item.name}</p>
              </div>
            </Col>
          </Row>
          <div className="item-line2">
            <LinkContainer exact to={`/donationstorepreview/${item.id}/${item.name}`}>
              <button className="details-button">View Details</button>
            </LinkContainer>
            <span style={{color: "gold", float: "right"}}>{item.price} Coins</span>
            <div style={{clear: "both"}}></div>
          </div>
          <hr/>
          <p>{item.description}</p>
        </div>
      </Col>
    ));
}
